import { css } from 'styled-components';
import type { TextStyleValue } from '@elfsight/configurator-contracts';
import type { StripeIntegrationSettings } from '@elfsight/lib-stripe-integration';
import {
  integrationStripeSettings,
  PAYMENT_EMAIL_FIELD_ID
} from '@elfsight/lib-stripe-integration';
import type { FormField } from '@elfsight/widget-form-builder/widget';
import type {
  CheckoutColors,
  CheckoutProductSettings,
  CheckoutSuccessSettings
} from './types';

export const NARROW_BREAKPOINT = 800;

export const STYLE_DEFAULTS: TextStyleValue & CheckoutColors = {
  textColor: '#111',
  accentColor: '#197BFF',
  errorColor: '#FF3838',
  backgroundColor: '#FFF',
  successColor: '#0E8B25',
  fontSize: 15,
  lineHeight: '20px',
  fontWeight: 400,
  textAlign: 'center'
};

export const PAYMENT_EMAIL_FIELD: FormField = {
  id: PAYMENT_EMAIL_FIELD_ID,
  label: 'Email',
  name: 'email',
  type: 'email',
  required: false,
  visible: true
};

export const STRETCH_FIT_MIXIN = css`
  min-width: 0;
  width: fit-content;
  max-width: 100%;
  flex: 0 1 auto;
`;

export const INVALID_VALUE_DASH = '—';

// константы для дефолтных настроек в виджетах, поэтому camelCase используется намеренно

export const checkoutCommonSettings: StripeIntegrationSettings &
  CheckoutSuccessSettings = {
  ...integrationStripeSettings,
  checkoutSuccessTitle: 'Payment Successful',
  checkoutSuccessText:
    'Your payment has been processed successfully. Thank you!'
};

export const checkoutProductSettings: CheckoutProductSettings = {
  checkoutProductName: '',
  checkoutProductDescription: '',
  checkoutProductImage: null
};
